import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    restpectiveUserIds: [],
};

const sentimentSlice = createSlice({
    name: "sentiment/Fisibility",
    initialState,
    reducers: {
        set_all_user_ids: (state, { payload }) => {
            state.restpectiveUserIds = payload;
        }
    }
});

export const { set_all_user_ids } = sentimentSlice.actions;
export default sentimentSlice;